module.exports = __webpack_public_path__ + "static/media/matchfound.f2d344fb.png";